/* shah */
import React from 'react'

const WidgetToggleButton = () => {
  return (
    <div className="ONOFFBUTTON-PARENT" >
    <label className="accessibility-switch" aria-label='switch button'>
      <input type="checkbox" className="checkOnOff "  />
      <span className="accessibility-slider "></span>
    </label>
  </div>
  )
}

export default WidgetToggleButton